import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useDocumentState } from '@/state'

import type { TemplateAttribute } from '@/lib/api/client'

export const useRelativeToAbsolutePositioning = () => {
  const getDocumentState = useDocumentState(
    useShallow((state) => state.getState),
  )

  const registerSelectableElementRef = useDocumentState(
    useShallow((state) => state.registerSelectableElementRef),
  )

  const relativeToAbsolutePosition = useCallback(
    (template: TemplateAttribute) => {
      const templateId = template.id
      const templateValues = template.template_values as any

      if (!templateId) {
        return null
      }

      const { getSelectableElementRef } = getDocumentState()

      const annotationParentRef = getSelectableElementRef(templateId)

      if (!annotationParentRef) {
        return null
      }

      const annoParentY = annotationParentRef.parentElement
        ? annotationParentRef.parentElement.offsetTop
        : annotationParentRef.offsetTop

      const annoParentX = annotationParentRef.parentElement
        ? annotationParentRef.parentElement.offsetLeft
        : annotationParentRef.offsetLeft

      const posX = templateValues?.position?.x || 0
      const posY = templateValues?.position?.y || 0

      const y = annoParentY + posY
      const x = annoParentX + posX

      return { x, y }
    },
    [getDocumentState],
  )

  return {
    relativeToAbsolutePosition,
    registerSelectableElementRef,
  }
}
